<template>
  <div class="cfm" :style="shellStyle" dir="rtl">
    <header class="cfm-header">
      <button
        type="button"
        class="cfm-header__icon cfm-header__back"
        :aria-label="$t('back')"
        @click="onBack"
      >
        <v-icon size="24" color="#37474F">mdi-arrow-left</v-icon>
      </button>
      <h1 class="cfm-header__title">{{ $t("customer&detail") }}</h1>
      <button
        type="button"
        class="cfm-header__icon cfm-header__list"
        :aria-label="$t('customerList')"
        @click="c.goTo('customerList')"
      >
        <v-icon size="22" color="#37474F">mdi-format-list-numbered</v-icon>
      </button>
    </header>

    <v-progress-linear
      :active="!c.render"
      :indeterminate="!c.render"
      absolute
      top
      color="#5B7C99"
      height="3"
    />

    <v-form
      v-if="c.render"
      ref="form"
      v-model="mobileValid"
      lazy-validation
      class="cfm__form"
      @submit.prevent
    >
      <section class="cfm-advanced cfm-advanced--top" dir="rtl">
        <div class="cfm-advanced__chips">
          <button
            type="button"
            class="cfm-advanced__chip"
            :class="{ 'cfm-advanced__chip--on': mobileTab === 'main' }"
            @click="setMobileTab('main')"
          >
            <v-icon size="16" :color="mobileTab === 'main' ? '#fff' : '#5B7C99'">mdi-account-outline</v-icon>
            <span>{{ $t("public-information") }}</span>
          </button>
          <button
            v-if="c.activeUser"
            type="button"
            class="cfm-advanced__chip"
            :class="{ 'cfm-advanced__chip--on': mobileTab === 'user' }"
            @click="setMobileTab('user')"
          >
            <v-icon size="16" :color="mobileTab === 'user' ? '#fff' : '#5B7C99'">mdi-account-key-outline</v-icon>
            <span>{{ $t("userInformation") }}</span>
          </button>
          <button
            type="button"
            class="cfm-advanced__chip"
            :class="{ 'cfm-advanced__chip--on': mobileTab === 'integrator' }"
            @click="setMobileTab('integrator')"
          >
            <v-icon size="16" :color="mobileTab === 'integrator' ? '#fff' : '#5B7C99'">mdi-transit-connection-variant</v-icon>
            <span>{{ $t("Integrator") }}</span>
          </button>
          <button
            v-if="documentPermmission"
            type="button"
            class="cfm-advanced__chip"
            :class="{ 'cfm-advanced__chip--on': mobileTab === 'documents' }"
            @click="setMobileTab('documents')"
          >
            <v-icon size="16" :color="mobileTab === 'documents' ? '#fff' : '#5B7C99'">mdi-file-document-outline</v-icon>
            <span>{{ $t("documents") }}</span>
          </button>
          <button
            v-if="c.activeUser && c.branchesItems != null"
            type="button"
            class="cfm-advanced__chip"
            :class="{ 'cfm-advanced__chip--on': mobileTab === 'sms' }"
            @click="setMobileTab('sms')"
          >
            <v-icon size="16" :color="mobileTab === 'sms' ? '#fff' : '#5B7C99'">mdi-message-text-outline</v-icon>
            <span>{{ $t("smses") }}</span>
          </button>
          <button
            v-if="showPersonnelyChip"
            type="button"
            class="cfm-advanced__chip"
            :class="{ 'cfm-advanced__chip--on': mobileTab === 'personnely' }"
            @click="setMobileTab('personnely')"
          >
            <v-icon size="16" :color="mobileTab === 'personnely' ? '#fff' : '#5B7C99'">mdi-badge-account-horizontal-outline</v-icon>
            <span>{{ $t("personnely") }}</span>
          </button>
        </div>
      </section>

      <div
        class="cfm__scroll"
        :class="{ 'cfm__scroll--documents': mobileTab === 'documents' }"
      >
        <!-- MAIN -->
        <div v-show="mobileTab === 'main'">
          <div class="cfm-flags" dir="rtl">
            <button
              type="button"
              class="cfm-flag"
              :class="{ 'cfm-flag--on': c.lead === 'active' }"
              :disabled="c.personel === 'active'"
              @click="toggleRole('lead')"
            >
              {{ $t("lead") }}
            </button>
            <button
              v-if="salaryPermission"
              type="button"
              class="cfm-flag"
              :class="{ 'cfm-flag--on': c.personnely === 'active' }"
              :disabled="c.lead === 'active'"
              @click="toggleRole('personnely')"
            >
              {{ $t("personnely") }}
            </button>
            <button
              type="button"
              class="cfm-flag"
              :class="{ 'cfm-flag--on': c.personel === 'active' }"
              :disabled="c.lead === 'active'"
              @click="toggleRole('personel')"
            >
              {{ $t("user") }}
            </button>
            <template v-if="learningPermission">
              <button
                type="button"
                class="cfm-flag"
                :class="{ 'cfm-flag--on': c.student === 'active' }"
                :disabled="c.lead === 'active'"
                @click="toggleRole('student')"
              >
                {{ $t("student", { name: $store.state.studentLabel }) }}
              </button>
              <button
                type="button"
                class="cfm-flag"
                :class="{ 'cfm-flag--on': c.teacher === 'active' }"
                :disabled="c.lead === 'active'"
                @click="toggleRole('teacher')"
              >
                {{ $t("teacher") }}
              </button>
            </template>
            <button
              v-if="commissionPermission"
              type="button"
              class="cfm-flag"
              :class="{ 'cfm-flag--on': c.visitor === 'active' }"
              :disabled="c.lead === 'active'"
              @click="toggleRole('visitor')"
            >
              {{ $t("visitor") }}
            </button>
            <button
              v-if="investorPermission"
              type="button"
              class="cfm-flag"
              :class="{ 'cfm-flag--on': c.investor === 'active' }"
              :disabled="c.lead === 'active'"
              @click="toggleRole('investor')"
            >
              {{ $t("investor") }}
            </button>
            <button
              v-if="translationPermission"
              type="button"
              class="cfm-flag"
              :class="{ 'cfm-flag--on': c.translator === 'active' }"
              :disabled="c.lead === 'active'"
              @click="toggleRole('translator')"
            >
              {{ $t("translator") }}
            </button>
          </div>

          <section class="cfm-card cfm-hero">
            <div class="cfm-hero__body">
              <div class="cfm-hero__toggles" dir="rtl">
                <div class="cfm-type cfm-type--compact">
                  <button
                    type="button"
                    class="cfm-type__item"
                    :class="{ 'cfm-type__item--active': c.personType === 'real' }"
                    @click="c.personType = 'real'"
                  >
                    {{ $t("Individual") }}
                  </button>
                  <button
                    type="button"
                    class="cfm-type__item"
                    :class="{ 'cfm-type__item--active': c.personType === 'company' }"
                    @click="c.personType = 'company'"
                  >
                    {{ $t("legal") }}
                  </button>
                </div>
                <div
                  v-if="c.personType === 'real'"
                  class="cfm-type cfm-type--compact"
                >
                  <button
                    type="button"
                    class="cfm-type__item"
                    :class="{ 'cfm-type__item--active': c.gender === 'man' }"
                    @click="c.gender = 'man'"
                  >
                    {{ $t("man") }}
                  </button>
                  <button
                    type="button"
                    class="cfm-type__item"
                    :class="{ 'cfm-type__item--active': c.gender === 'woman' }"
                    @click="c.gender = 'woman'"
                  >
                    {{ $t("woman") }}
                  </button>
                </div>
              </div>

              <div class="cfm-hero__row">
                <div class="cfm-hero__avatar">
                  <file-picker
                    ref="refFilePicker"
                    v-model="c.imagePicker"
                    :label="$t('uploadImage')"
                    :avatar="true"
                    :multiple="false"
                    extensions="image/png, image/gif, image/jpeg"
                    type-prop="personAvatar"
                    :val="c.imagePickerVal ? c.imagePickerVal : null"
                  />
                </div>
                <div class="cfm-hero__main">
                  <v-text-field
                    v-model="c.firstname"
                    :label="$t('name')"
                    :rules="[(v) => !!v || $t('is-required')]"
                    dense
                    outlined
                    hide-details
                    class="cfm-hero__name ma-0"
                    clearable
                  />
                  <v-text-field
                    v-if="c.gender !== 'company'"
                    v-model="c.lastname"
                    :label="$t('last-name')"
                    dense
                    outlined
                    hide-details
                    class="cfm-hero__lastname ma-0"
                    clearable
                  />
                </div>
              </div>

              <div class="cfm-hero__fields">
                <v-text-field
                  v-model="c.nationalCode"
                  :label="$t('national-code')"
                  dense
                  outlined
                  hide-details
                  class="cfm-hero__field ma-0"
                  clearable
                />
                <div class="cfm-hero__fields-gap" aria-hidden="true" />
                <v-text-field
                  v-model="c.mobile"
                  :label="$t('mobile')"
                  dense
                  outlined
                  hide-details
                  class="cfm-hero__field ma-0"
                  clearable
                />
              </div>

              <div class="cfm-hero__status-row">
                <span class="cfm-hero__status-label">
                  {{ c.status === "active" ? $t("active") : $t("deactive") }}
                </span>
                <v-switch
                  class="mt-0 pt-0 cfm-hero__status"
                  dense
                  inset
                  hide-details
                  :input-value="c.status === 'active'"
                  color="#5B7C99"
                  @change="onStatusChange"
                />
              </div>
            </div>
          </section>

          <section class="cfm-card cfm-sections">
            <button type="button" class="cfm-sections__row" @click="openSection('contact')">
              <v-icon class="cfm-sections__icon" size="22" color="#5B7C99">mdi-phone-outline</v-icon>
              <div class="cfm-sections__copy">
                <div class="cfm-sections__title">{{ $t("otherCantactInfo") }}</div>
                <div class="cfm-sections__hint">{{ $t("email") }} , {{ $t("phone") }} , {{ $t("address") }} , ...</div>
              </div>
              <v-icon size="20" color="#B0BEC5">mdi-chevron-down</v-icon>
            </button>
            <button type="button" class="cfm-sections__row" @click="openSection('grouping')">
              <v-icon class="cfm-sections__icon" size="22" color="#5B7C99">mdi-tag-outline</v-icon>
              <div class="cfm-sections__copy">
                <div class="cfm-sections__title">{{ $t("grouping,tags") }}</div>
                <div class="cfm-sections__hint">{{ $t("tag") }} , {{ $t("category") }} , ...</div>
              </div>
              <v-icon size="20" color="#B0BEC5">mdi-chevron-down</v-icon>
            </button>
            <button type="button" class="cfm-sections__row" @click="openSection('identity')">
              <v-icon class="cfm-sections__icon" size="22" color="#5B7C99">mdi-card-account-details-outline</v-icon>
              <div class="cfm-sections__copy">
                <div class="cfm-sections__title">{{ $t("otherIdentityInformation") }}</div>
                <div class="cfm-sections__hint">{{ $t("birthDate") }} , {{ $t("financial-code") }} , ...</div>
              </div>
              <v-icon size="20" color="#B0BEC5">mdi-chevron-down</v-icon>
            </button>
            <button
              v-if="$store.state.isMainYear"
              type="button"
              class="cfm-sections__row"
              @click="openSection('financial')"
            >
              <v-icon class="cfm-sections__icon" size="22" color="#5B7C99">mdi-cash-multiple</v-icon>
              <div class="cfm-sections__copy">
                <div class="cfm-sections__title">{{ $t("financialInformation") }}</div>
                <div class="cfm-sections__hint">{{ $t("initialRemainingAndFinancialStatus") }}</div>
              </div>
              <v-icon size="20" color="#B0BEC5">mdi-chevron-down</v-icon>
            </button>
            <button
              v-if="customFieldsPermission"
              type="button"
              class="cfm-sections__row"
              @click="openSection('customFields')"
            >
              <v-icon class="cfm-sections__icon" size="22" color="#5B7C99">mdi-form-textbox</v-icon>
              <div class="cfm-sections__copy">
                <div class="cfm-sections__title">{{ $t("customFields") }}</div>
                <div class="cfm-sections__hint">{{ $t("customeFeildDescrible") }}</div>
              </div>
              <v-icon size="20" color="#B0BEC5">mdi-chevron-down</v-icon>
            </button>
            <button type="button" class="cfm-sections__row" @click="openSection('other')">
              <v-icon class="cfm-sections__icon" size="22" color="#5B7C99">mdi-cog-outline</v-icon>
              <div class="cfm-sections__copy">
                <div class="cfm-sections__title">{{ $t("otherInformation") }}</div>
                <div class="cfm-sections__hint">{{ $t("branch") }} , {{ $t("content") }} , ...</div>
              </div>
              <v-icon size="20" color="#B0BEC5">mdi-chevron-down</v-icon>
            </button>
          </section>
        </div>

        <!-- USER -->
        <div v-show="mobileTab === 'user'" class="cfm-tab-panel">
          <section class="cfm-card cfm-user-card">
            <div class="cfm-type cfm-type--compact mb-3">
              <button
                type="button"
                class="cfm-type__item"
                :class="{ 'cfm-type__item--active': c.personnelType === 'personnel' }"
                @click="c.personnelType = 'personnel'"
              >
                {{ $t("personnel") }}
              </button>
              <button
                type="button"
                class="cfm-type__item"
                :class="{ 'cfm-type__item--active': c.personnelType === 'customer' }"
                @click="c.personnelType = 'customer'"
              >
                {{ $t("customer") }}
              </button>
            </div>

            <div class="cfm-user-card__fields">
              <div class="cfm-composer-field">
                <div class="cfm-composer-field__label">{{ $t("username") }}</div>
                <input
                  v-model="c.username"
                  type="text"
                  class="cfm-integ__input"
                  :class="{ 'cfm-integ__input--disabled': c.personelStatus == 'active' }"
                  :placeholder="$t('username')"
                  :disabled="c.personelStatus == 'active'"
                  autocomplete="username"
                  @change="c.checkUser"
                >
              </div>

              <template v-if="c.personnelType === 'personnel'">
                <div v-if="!c.id" class="cfm-composer-field">
                  <div class="cfm-composer-field__label">{{ $t("password") }}</div>
                  <input
                    v-model="c.password"
                    type="password"
                    class="cfm-integ__input"
                    :class="{
                      'cfm-integ__input--disabled':
                        c.isLoading || (!c.isLoading && c.isUserRepitetive != null),
                    }"
                    :placeholder="$t('password')"
                    :disabled="c.isLoading || (!c.isLoading && c.isUserRepitetive != null)"
                    autocomplete="new-password"
                  >
                </div>

                <div class="cfm-composer-field">
                  <div class="cfm-composer-field__label">{{ $t("userRole") }}</div>
                  <button
                    type="button"
                    class="cfm-integ__input cfm-integ__input--date"
                    @click="openPicker('refRole')"
                  >
                    <span :class="{ 'cfm-integ__ph': !roleText }">
                      {{ roleText || $t("userRole") }}
                    </span>
                    <v-icon size="18" color="#90A4AE">mdi-chevron-down</v-icon>
                  </button>
                </div>

                <div class="cfm-composer-field">
                  <div class="cfm-composer-field__label">{{ $t("entrepotAccess") }}</div>
                  <button
                    type="button"
                    class="cfm-integ__input cfm-integ__input--date"
                    :class="{ 'cfm-integ__input--disabled': !$store.state.access }"
                    :disabled="!$store.state.access"
                    @click="openPicker('refEntrepot')"
                  >
                    <span :class="{ 'cfm-integ__ph': !entrepotAccessText }">
                      {{ entrepotAccessText || $t("entrepotAccess") }}
                    </span>
                    <v-icon size="18" color="#90A4AE">mdi-chevron-down</v-icon>
                  </button>
                </div>

                <div class="cfm-composer-field">
                  <div class="cfm-composer-field__label">{{ $t("branch") }}</div>
                  <button
                    type="button"
                    class="cfm-integ__input cfm-integ__input--date"
                    @click="openPicker('refBranchAccess')"
                  >
                    <span :class="{ 'cfm-integ__ph': !branchAccessText }">
                      {{ branchAccessText || $t("branch") }}
                    </span>
                    <v-icon size="18" color="#90A4AE">mdi-chevron-down</v-icon>
                  </button>
                </div>

                <div v-if="c.isSupport" class="cfm-composer-field">
                  <div class="cfm-composer-field__label">{{ $t("departmentAccess") }}</div>
                  <button
                    type="button"
                    class="cfm-integ__input cfm-integ__input--date"
                    @click="openPicker('refDepartmentAccess')"
                  >
                    <span :class="{ 'cfm-integ__ph': !departmentAccessText }">
                      {{ departmentAccessText || $t("departmentAccess") }}
                    </span>
                    <v-icon size="18" color="#90A4AE">mdi-chevron-down</v-icon>
                  </button>
                </div>

                <div class="cfm-composer-field">
                  <div class="cfm-composer-field__label">
                    {{ $t("bank") + "/" + $t("cash") + "/" + $t("petty") }}
                  </div>
                  <button
                    type="button"
                    class="cfm-integ__input cfm-integ__input--date"
                    @click="openPicker('refBank')"
                  >
                    <span :class="{ 'cfm-integ__ph': !bankAccessText }">
                      {{ bankAccessText || $t("bank") + "/" + $t("cash") + "/" + $t("petty") }}
                    </span>
                    <v-icon size="18" color="#90A4AE">mdi-chevron-down</v-icon>
                  </button>
                </div>

                <!-- Hidden pickers: opened via Digikala-style rows (one-tap) -->
                <div class="cfm-picker-host" aria-hidden="true">
                  <autocomplete
                    ref="refRole"
                    v-model="c.role"
                    :title="$t('userRole')"
                    type="role"
                    :set-init="true"
                    :value="c.role"
                  />
                  <autocomplete
                    ref="refEntrepot"
                    v-model="c.entrepotAccess"
                    :title="$t('entrepotAccess')"
                    :multiple="true"
                    :value="c.entrepotAccess"
                    :data="JSON.stringify({ withoutAccess: 'active' })"
                    type="entrepot"
                    :disabled="!$store.state.access ? true : false"
                  />
                  <aicomplete
                    ref="refBranchAccess"
                    v-model="c.branchAccess"
                    title="branch"
                    type="branch"
                    :val="c.branchAccess"
                    :multiple="true"
                    :new-btn="true"
                  />
                  <autocomplete
                    v-if="c.isSupport"
                    ref="refDepartmentAccess"
                    v-model="c.departmentAccess"
                    :title="$t('departmentAccess')"
                    :multiple="true"
                    :value="c.departmentAccess"
                    type="departments"
                  />
                  <autocomplete
                    ref="refBank"
                    v-model="c.bank"
                    :title="$t('bank') + '/' + $t('cash') + '/' + $t('petty')"
                    type="allBankCash"
                    :outlined="true"
                    :multiple="true"
                    :value="c.bank"
                  />
                </div>

                <div class="cfm-composer-field cfm-composer-field--switch">
                  <div class="cfm-composer-field__label">{{ $t("admin") }}</div>
                  <v-switch
                    class="mt-0 pt-0"
                    dense
                    inset
                    hide-details
                    :disabled="!$store.state.admin"
                    :input-value="c.admin === 'active'"
                    color="#5B7C99"
                    @change="(v) => (c.admin = v ? 'active' : null)"
                  />
                </div>
                <div class="cfm-composer-field cfm-composer-field--switch">
                  <div class="cfm-composer-field__label">{{ $t("deactiveChangeSellPrice") }}</div>
                  <v-switch
                    class="mt-0 pt-0"
                    dense
                    inset
                    hide-details
                    :disabled="!$store.state.access"
                    :input-value="c.deactiveChangeSellPrice === 'active'"
                    color="#5B7C99"
                    @change="(v) => (c.deactiveChangeSellPrice = v ? 'active' : null)"
                  />
                </div>
                <div class="cfm-composer-field cfm-composer-field--switch">
                  <div class="cfm-composer-field__label">{{ $t("deactiveBranchAccess") }}</div>
                  <v-switch
                    class="mt-0 pt-0"
                    dense
                    inset
                    hide-details
                    :disabled="!$store.state.access"
                    :input-value="c.deactiveBranchAccess === 'active'"
                    color="#5B7C99"
                    @change="(v) => (c.deactiveBranchAccess = v ? 'active' : null)"
                  />
                </div>
                <div class="cfm-composer-field cfm-composer-field--switch">
                  <div class="cfm-composer-field__label">
                    {{ $t("show only inStock product while searching") }}
                  </div>
                  <v-switch
                    class="mt-0 pt-0"
                    dense
                    inset
                    hide-details
                    :input-value="c.configs.showInStockProduct === 'active'"
                    color="#5B7C99"
                    @change="(v) => (c.configs.showInStockProduct = v ? 'active' : null)"
                  />
                </div>
              </template>
            </div>
          </section>
        </div>

        <!-- INTEGRATOR -->
        <div v-show="mobileTab === 'integrator'" class="cfm-tab-panel cfm-integ">
          <div class="cfm-integ__chips">
            <button
              v-for="tab in integratorSubTabs"
              :key="'integ-' + tab.key"
              type="button"
              class="cfm-integ__chip"
              :class="{ 'cfm-integ__chip--on': integratorSubTab === tab.key }"
              @click="integratorSubTab = tab.key"
            >
              <v-icon
                v-if="tab.icon"
                size="16"
                :color="integratorSubTab === tab.key ? '#fff' : '#5B7C99'"
              >
                {{ tab.icon }}
              </v-icon>
              <img
                v-else-if="tab.img"
                :src="tab.img"
                :alt="tab.label"
                class="cfm-integ__chip-logo"
              >
              <span>{{ tab.label }}</span>
            </button>
          </div>

          <div v-show="integratorSubTab === 'woocommerce'" class="cfm-integ__panel">
            <button
              type="button"
              class="cfm-integ__add"
              :disabled="c.isLoading"
              @click="addWooMobile"
            >
              <v-icon size="18" color="#5A6B85">mdi-plus</v-icon>
              <span>{{ $t("addId") }}</span>
            </button>
            <div
              v-if="!(c.woocommerceIdItems && c.woocommerceIdItems.length)"
              class="cfm-integ__empty"
            >
              <v-icon size="28" color="#90A4AE">mdi-link-variant-off</v-icon>
              <div class="cfm-integ__empty-title">{{ $t("no-data") }}</div>
              <div class="cfm-integ__empty-hint">{{ $t("addId") }}</div>
            </div>
            <div
              v-for="(item, h) in c.woocommerceIdItems"
              :key="'woo-' + h"
              class="cfm-integ__card"
              :class="{ 'cfm-integ__card--open': wooOpenIndex === h }"
            >
              <div
                class="cfm-integ__card-top"
                role="button"
                tabindex="0"
                @click="toggleWooCard(h)"
                @keydown.enter.prevent="toggleWooCard(h)"
                @keydown.space.prevent="toggleWooCard(h)"
              >
                <div class="cfm-integ__card-head">
                  <v-icon size="20" color="#78909C">
                    {{ wooOpenIndex === h ? "mdi-chevron-up" : "mdi-chevron-down" }}
                  </v-icon>
                  <div class="cfm-integ__card-titles">
                    <span class="cfm-integ__card-title">{{ $t("row") }} {{ h + 1 }}</span>
                    <span class="cfm-integ__card-summary">{{ wooCardSummary(item) }}</span>
                  </div>
                </div>
                <button
                  type="button"
                  class="cfm-integ__card-remove"
                  :aria-label="$t('remove')"
                  @click.stop="c.removeWoocommerceId(item)"
                >
                  <v-icon size="20" color="#E91E63">mdi-trash-can-outline</v-icon>
                </button>
              </div>
              <div v-show="wooOpenIndex === h" class="cfm-integ__card-body">
                <div class="cfm-composer-field">
                  <div class="cfm-composer-field__label">{{ $t("woocommercePanelName") }}</div>
                  <autocomplete
                    v-model="item.woocommercePanelName"
                    title=""
                    :value="item.woocommercePanelName"
                    type="woocommercePanelName"
                    class="cfm-integ__picker"
                  />
                </div>
                <div class="cfm-composer-field">
                  <div class="cfm-composer-field__label">{{ $t("woocommerceId") }}</div>
                  <input
                    v-model="item.woocommerceId"
                    type="text"
                    class="cfm-integ__input"
                    :placeholder="$t('woocommerceId')"
                    autocomplete="off"
                  >
                </div>
              </div>
            </div>
          </div>

          <div v-show="integratorSubTab === 'digikala'" class="cfm-integ__panel">
            <div class="cfm-integ__simple">
              <div class="cfm-composer-field">
                <div class="cfm-composer-field__label">{{ $t("digikalaId") }}</div>
                <input
                  v-model="c.digikalaId"
                  type="text"
                  class="cfm-integ__input"
                  :placeholder="$t('digikalaId')"
                  disabled
                  autocomplete="off"
                >
              </div>
            </div>
          </div>
          <div v-show="integratorSubTab === 'portal'" class="cfm-integ__panel">
            <div class="cfm-integ__simple">
              <div class="cfm-composer-field">
                <div class="cfm-composer-field__label">{{ $t("portalId") }}</div>
                <input
                  v-model="c.portalId"
                  type="text"
                  class="cfm-integ__input"
                  :placeholder="$t('portalId')"
                  autocomplete="off"
                >
              </div>
            </div>
          </div>
          <div v-show="integratorSubTab === 'sazito'" class="cfm-integ__panel">
            <div class="cfm-integ__simple">
              <div class="cfm-composer-field">
                <div class="cfm-composer-field__label">{{ $t("sazitoId") }}</div>
                <input
                  v-model="c.sazitoId"
                  type="text"
                  class="cfm-integ__input"
                  :placeholder="$t('sazitoId')"
                  autocomplete="off"
                >
              </div>
            </div>
          </div>
          <div v-show="integratorSubTab === 'magnet'" class="cfm-integ__panel">
            <div class="cfm-integ__simple">
              <div class="cfm-composer-field">
                <div class="cfm-composer-field__label">{{ $t("magnetId") }}</div>
                <input
                  v-model="c.magnetId"
                  type="text"
                  class="cfm-integ__input"
                  :placeholder="$t('magnetId')"
                  autocomplete="off"
                >
              </div>
            </div>
          </div>
          <div v-show="integratorSubTab === 'webzi'" class="cfm-integ__panel">
            <div class="cfm-integ__simple">
              <div class="cfm-composer-field cfm-composer-field--switch">
                <div class="cfm-composer-field__label">{{ $t("webziSeller") }}</div>
                <v-switch
                  class="mt-0 pt-0"
                  dense
                  inset
                  hide-details
                  :input-value="c.webziSeller === 'active'"
                  color="#5B7C99"
                  @change="(v) => (c.webziSeller = v ? 'active' : null)"
                />
              </div>
              <div class="cfm-composer-field">
                <div class="cfm-composer-field__label">{{ $t("webziId") }}</div>
                <input
                  v-model="c.webziId"
                  type="text"
                  class="cfm-integ__input"
                  :placeholder="$t('webziId')"
                  autocomplete="off"
                >
              </div>
              <div class="cfm-composer-field">
                <div class="cfm-composer-field__label">{{ $t("webziSellerCommission") }}</div>
                <input
                  v-model="c.webziSellerCommission"
                  type="text"
                  class="cfm-integ__input"
                  :placeholder="$t('webziSellerCommission')"
                  autocomplete="off"
                >
              </div>
            </div>
          </div>
        </div>

        <!-- DOCUMENTS (visual pattern: pay/cash — no page shell class) -->
        <div
          v-if="mobileTab === 'documents'"
          class="cfm-tab-panel cfm-documents"
        >
          <form-attachment-doc
            ref="refFilePickerDocument"
            v-model="c.attachments"
            type-prop="account"
            :val="c.id && c.attachments ? c.attachments : null"
            card-class="cfm-documents__card"
          />
        </div>

        <!-- SMS -->
        <div v-show="mobileTab === 'sms'" class="cfm-tab-panel">
          <v-expansion-panels v-model="c.panelBranch" class="cfm-branch-panel" multiple>
            <v-expansion-panel
              v-for="(branch, index) in c.branchesItems"
              :key="branch.id || index"
            >
              <v-expansion-panel-header>
                <div class="d-flex align-center gap-2">
                  <v-icon size="15">mdi-source-branch</v-icon>
                  <span>{{ branch.name }}</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-treeview
                  v-model="branch.smsTree"
                  :items="c.treeItems"
                  item-key="id"
                  selectable
                  open-on-click
                  selected-color="#5B7C99"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <!-- PERSONNELY / HRM -->
        <div v-show="mobileTab === 'personnely'" class="cfm-tab-panel">
          <section class="cfm-card cfm-personnely-work mb-3">
            <div class="cfm-personnely-work__title">{{ $t("workInformation") }}</div>
            <div class="cfm-personnely-work__fields">
              <div class="cfm-personnely-work__dates">
                <div class="cfm-composer-field">
                  <div class="cfm-composer-field__label">{{ $t("startToWork") }}</div>
                  <button
                    type="button"
                    class="cfm-integ__input cfm-integ__input--date"
                    @click="openDateSheet(c, 'startToWork', $t('startToWork'))"
                  >
                    <span :class="{ 'cfm-integ__ph': !c.startToWork }">
                      {{ c.startToWork || $t("startToWork") }}
                    </span>
                    <v-icon size="18" color="#90A4AE">mdi-calendar</v-icon>
                  </button>
                </div>
                <div class="cfm-composer-field">
                  <div class="cfm-composer-field__label">{{ $t("EndToWork") }}</div>
                  <button
                    type="button"
                    class="cfm-integ__input cfm-integ__input--date"
                    @click="openDateSheet(c, 'EndToWork', $t('EndToWork'))"
                  >
                    <span :class="{ 'cfm-integ__ph': !c.EndToWork }">
                      {{ c.EndToWork || $t("EndToWork") }}
                    </span>
                    <v-icon size="18" color="#90A4AE">mdi-calendar</v-icon>
                  </button>
                </div>
              </div>
              <div class="cfm-composer-field">
                <div class="cfm-composer-field__label">{{ $t("personnelCode") }}</div>
                <input
                  v-model="c.personnelCode"
                  type="text"
                  class="cfm-integ__input"
                  :placeholder="$t('personnelCode')"
                  autocomplete="off"
                >
              </div>
              <div class="cfm-composer-field">
                <div class="cfm-composer-field__label">{{ $t("workshop") }}</div>
                <FlexibleAutocomplete
                  v-model="c.workshop"
                  title=""
                  type="WorkshopType"
                  :multiple="false"
                  :currency="c.currencyId"
                  :fetchData="c.fetchWorkshopApi"
                  class="cfm-integ__picker"
                />
              </div>
              <div class="cfm-composer-field">
                <div class="cfm-composer-field__label">{{ $t("AssetsRole") }}</div>
                <FlexibleAutocomplete
                  v-model="c.finance_job_position"
                  title=""
                  type="finance_job_position"
                  :multiple="false"
                  :currency="c.currencyId"
                  :fetchData="c.fetchApi"
                  class="cfm-integ__picker"
                />
              </div>
              <div class="cfm-composer-field">
                <div class="cfm-composer-field__label">{{ $t("bank-name") }}</div>
                <input
                  v-model="c.bankName"
                  type="text"
                  class="cfm-integ__input"
                  :placeholder="$t('bank-name')"
                  autocomplete="off"
                >
              </div>
              <div class="cfm-composer-field">
                <div class="cfm-composer-field__label">{{ $t("SalaryAccountNumber") }}</div>
                <input
                  v-model="c.SalaryAccountNumber"
                  type="text"
                  class="cfm-integ__input"
                  :placeholder="$t('SalaryAccountNumber')"
                  autocomplete="off"
                >
              </div>
              <div class="cfm-composer-field">
                <div class="cfm-composer-field__label">{{ $t("employmentType") }}</div>
                <FlexibleAutocomplete
                  v-model="c.type_of_employment"
                  title=""
                  :currency="c.currencyId"
                  type="type_of_employment"
                  :multiple="false"
                  :fetchData="c.fetchApi"
                  class="cfm-integ__picker"
                />
              </div>
              <div class="cfm-composer-field">
                <div class="cfm-composer-field__label">{{ $t("contractType") }}</div>
                <FlexibleAutocomplete
                  v-model="c.type_of_contract"
                  title=""
                  type="type_of_contract"
                  :multiple="false"
                  :currency="c.currencyId"
                  :fetchData="c.fetchApi"
                  class="cfm-integ__picker"
                />
              </div>
            </div>
          </section>

          <section class="cfm-card cfm-sections">
            <button
              type="button"
              class="cfm-sections__row"
              @click="openSection('personnelyInsurer')"
            >
              <v-icon class="cfm-sections__icon" size="22" color="#5B7C99">
                mdi-shield-account-outline
              </v-icon>
              <div class="cfm-sections__copy">
                <div class="cfm-sections__title">{{ $t("InsurerInformation") }}</div>
                <div class="cfm-sections__hint">
                  {{ $t("InsurerName") }} , {{ $t("InsurerNumber") }} , ...
                </div>
              </div>
              <v-icon size="20" color="#B0BEC5">mdi-chevron-down</v-icon>
            </button>
            <button
              type="button"
              class="cfm-sections__row"
              @click="openSection('personnelyService')"
            >
              <v-icon class="cfm-sections__icon" size="22" color="#5B7C99">
                mdi-medal-outline
              </v-icon>
              <div class="cfm-sections__copy">
                <div class="cfm-sections__title">{{ $t("Serviceinformation") }}</div>
                <div class="cfm-sections__hint">
                  {{ $t("Military Service Status") }} , {{ $t("jobCategory") }} , ...
                </div>
              </div>
              <v-icon size="20" color="#B0BEC5">mdi-chevron-down</v-icon>
            </button>
          </section>
        </div>
      </div>

      <div class="cfm-actions" :style="actionsStyle">
        <v-btn
          v-if="!c.id"
          class="cfm-actions__primary"
          block
          height="40"
          :loading="c.isLoading"
          @click="submitCreate"
        >
          {{ $t("submit") }}
        </v-btn>
        <v-btn
          v-else
          class="cfm-actions__primary"
          block
          height="40"
          :loading="c.isLoading"
          @click="submitUpdate"
        >
          {{ $t("submit") }}
        </v-btn>
      </div>

      <!-- Always-mounted identity refs (desktop panel is eager) for create() validation -->
      <div class="cfm-picker-host" aria-hidden="true">
        <v-text-field
          ref="refBirthDate"
          v-model="c.birthDate"
          :rules="[c.personnelyConditionRule]"
        />
        <v-text-field
          ref="refFathersName"
          v-model="c.fathersName"
          :rules="[c.personnelyConditionRule]"
        />
        <v-text-field
          ref="refBirthCertificateNumber"
          v-model="c.BirthCertificateNumber"
          :rules="[c.personnelyConditionRule]"
        />
        <v-text-field
          ref="refDateOfBirthCertificate"
          v-model="c.dateOfBirthCertificate"
          :rules="[c.personnelyConditionRule]"
        />
      </div>
    </v-form>

    <!-- Section bottom sheet -->
    <v-bottom-sheet v-model="sectionSheet" eager>
      <v-card class="amf-sheet cfm-section-sheet" dir="rtl">
        <div class="amf-sheet__handle" />
        <div class="amf-sheet__header">
          <span class="amf-sheet__header-spacer" />
          <div class="amf-sheet__title">{{ sectionTitle }}</div>
          <button
            type="button"
            class="amf-sheet__back"
            :aria-label="$t('back')"
            @click="sectionSheet = false"
          >
            <v-icon size="22" color="#37474F">mdi-arrow-left</v-icon>
          </button>
        </div>

        <div
          v-if="sectionHasAddAction"
          class="cfm-section-sheet__toolbar cfm-section-sheet__toolbar--composer"
        >
          <div class="cfm-section-sheet__hint">
            {{ sectionAddHint }}
          </div>
          <button
            type="button"
            class="cfm-section-sheet__add"
            @click="onSectionAdd"
          >
            <v-icon size="18" color="#5A6B85">mdi-plus</v-icon>
            <span>{{ sectionAddLabel }}</span>
          </button>
        </div>

        <div class="cfm-section-sheet__scroll amf-sheet__body--stack">
          <!-- Contact: Digikala-style rows (same as product sheet fields) -->
          <template v-if="activeSection === 'contact'">
            <div class="cfm-sheet-fields">
              <div class="cfm-field">
                <div class="cfm-field__label-wrap">
                  <v-icon size="18" color="#5B7C99">mdi-email-outline</v-icon>
                  <span class="cfm-field__label">{{ $t("email") }}</span>
                </div>
                <div class="cfm-field__control">
                  <input
                    v-model="c.email"
                    type="email"
                    class="cfm-field__input"
                  >
                  <v-icon
                    v-if="c.email"
                    size="16"
                    color="#90A4AE"
                  >mdi-pencil-outline</v-icon>
                </div>
              </div>
              <div class="cfm-field">
                <div class="cfm-field__label-wrap">
                  <v-icon size="18" color="#5B7C99">mdi-phone-outline</v-icon>
                  <span class="cfm-field__label">{{ $t("phone") }}</span>
                </div>
                <div class="cfm-field__control">
                  <input
                    v-model="c.phone"
                    type="tel"
                    class="cfm-field__input"
                  >
                  <v-icon
                    v-if="c.phone"
                    size="16"
                    color="#90A4AE"
                  >mdi-pencil-outline</v-icon>
                </div>
              </div>
              <div class="cfm-field cfm-field--select" @click="openPicker('refCountry')">
                <div class="cfm-field__label-wrap">
                  <v-icon size="18" color="#5B7C99">mdi-earth</v-icon>
                  <span class="cfm-field__label">{{ $t("country") }}</span>
                </div>
                <button type="button" class="cfm-field__control cfm-field__control--select">
                  <span>{{ countryText }}</span>
                  <v-icon size="18" color="#90A4AE">mdi-chevron-down</v-icon>
                </button>
              </div>
              <div class="cfm-field cfm-field--select" @click="openPicker('refState')">
                <div class="cfm-field__label-wrap">
                  <v-icon size="18" color="#5B7C99">mdi-map-outline</v-icon>
                  <span class="cfm-field__label">{{ $t("state") }}</span>
                </div>
                <button type="button" class="cfm-field__control cfm-field__control--select">
                  <span>{{ stateText }}</span>
                  <v-icon size="18" color="#90A4AE">mdi-chevron-down</v-icon>
                </button>
              </div>
              <div class="cfm-field cfm-field--select" @click="openPicker('refCity')">
                <div class="cfm-field__label-wrap">
                  <v-icon size="18" color="#5B7C99">mdi-home-city-outline</v-icon>
                  <span class="cfm-field__label">{{ $t("city") }}</span>
                </div>
                <button type="button" class="cfm-field__control cfm-field__control--select">
                  <span>{{ cityText }}</span>
                  <v-icon size="18" color="#90A4AE">mdi-chevron-down</v-icon>
                </button>
              </div>
              <div class="cfm-field cfm-field--area">
                <div class="cfm-field__label-wrap">
                  <v-icon size="18" color="#5B7C99">mdi-map-marker-outline</v-icon>
                  <span class="cfm-field__label">{{ $t("address") }}</span>
                </div>
                <textarea
                  v-model="c.address"
                  class="cfm-field__textarea"
                  rows="3"
                />
              </div>
              <div class="cfm-field">
                <div class="cfm-field__label-wrap">
                  <v-icon size="18" color="#5B7C99">mdi-mailbox-outline</v-icon>
                  <span class="cfm-field__label">{{ $t("postal-code") }}</span>
                </div>
                <div class="cfm-field__control">
                  <input
                    v-model="c.postalCode"
                    type="text"
                    class="cfm-field__input"
                  >
                  <v-icon
                    v-if="c.postalCode"
                    size="16"
                    color="#90A4AE"
                  >mdi-pencil-outline</v-icon>
                </div>
              </div>
            </div>
          </template>

          <!-- Grouping -->
          <template v-else-if="activeSection === 'grouping'">
            <aicomplete
              ref="refCategory"
              v-model="c.category"
              title="category"
              type="accountCategory"
              :val="c.category"
              :new-btn="true"
              class="mb-2"
            />
            <tag v-model="c.tag" :solo="false" :input="c.tag" />
          </template>

          <!-- Identity -->
          <template v-else-if="activeSection === 'identity'">
            <div class="cfm-field cfm-field--switch">
              <span class="cfm-field__label">{{ $t("married") }}</span>
              <v-switch
                class="mt-0 pt-0 cfm-field__switch"
                dense
                inset
                hide-details
                :disabled="c.lead == 'active'"
                :input-value="!!c.married"
                color="#5B7C99"
                @change="(v) => (c.married = !!v)"
              />
            </div>
            <v-text-field
              ref="refBusinessName"
              v-model="c.businessName"
              :label="$t('business-name')"
              dense
              outlined
              clearable
              hide-details="auto"
              class="mb-2"
            />
            <v-text-field
              ref="refFinancialCode"
              v-model="c.financialCode"
              :label="$t('financial-code')"
              dense
              outlined
              clearable
              hide-details="auto"
              class="mb-2"
            />
            <v-text-field v-model="c.customerBranch" :label="$t('branch-name')" dense outlined clearable hide-details="auto" class="mb-2" />
            <v-text-field v-model="c.customerTaxCodeBranch" :label="$t('branch-tax-code')" dense outlined clearable hide-details="auto" class="mb-2" />
            <v-text-field
              v-model="c.birthDate"
              :label="$t('birthDate')"
              dense
              outlined
              clearable
              hide-details="auto"
              class="mb-2"
              readonly
              append-icon="mdi-calendar"
              @click="openDateSheet(c, 'birthDate', $t('birthDate'))"
              @click:append="openDateSheet(c, 'birthDate', $t('birthDate'))"
            />
            <aicomplete
              ref="refStatePlaceofBirth"
              v-model="c.statePlaceofBirth"
              title="statePlaceofBirth"
              type="state"
              :val="c.statePlaceofBirth"
              :new-btn="true"
              :data="JSON.stringify({ parent: c.country ? c.country.id : null })"
              :parent="c.country ? c.country.id : null"
              class="mb-2 mt-2"
            />
            <aicomplete
              ref="refCityPlaceofBirth"
              v-model="c.cityPlaceofBirth"
              title="cityPlaceofBirth"
              type="city"
              :val="c.cityPlaceofBirth"
              :new-btn="true"
              :data="JSON.stringify({ parent: c.country ? c.country.id : null })"
              :parent="c.state ? c.state.id : null"
              class="mb-2"
            />
            <v-text-field
              v-model="c.fathersName"
              :label="$t('fathersName')"
              dense
              outlined
              clearable
              hide-details="auto"
              class="mb-2"
            />
            <v-text-field
              v-model="c.BirthCertificateNumber"
              :label="$t('Birth Certificate Number')"
              dense
              outlined
              clearable
              hide-details="auto"
              class="mb-2"
            />
            <v-text-field
              v-model="c.dateOfBirthCertificate"
              :label="$t('dateOfBirthCertificate')"
              dense
              outlined
              clearable
              hide-details="auto"
              class="mb-2"
              readonly
              append-icon="mdi-calendar"
              @click="openDateSheet(c, 'dateOfBirthCertificate', $t('dateOfBirthCertificate'))"
              @click:append="openDateSheet(c, 'dateOfBirthCertificate', $t('dateOfBirthCertificate'))"
            />
            <aicomplete
              ref="refStatePlaceOfBirthCertificate"
              v-model="c.statePlaceOfBirthCertificate"
              title="statePlaceOfBirthCertificate"
              type="state"
              :val="c.statePlaceOfBirthCertificate"
              :new-btn="true"
              :data="JSON.stringify({ parent: c.country ? c.country.id : null })"
              :parent="c.country ? c.country.id : null"
              class="mb-2 mt-2"
            />
            <aicomplete
              ref="refCityPlaceOfBirthCertificate"
              v-model="c.cityPlaceOfBirthCertificate"
              title="cityPlaceOfBirthCertificate"
              type="city"
              :val="c.cityPlaceOfBirthCertificate"
              :new-btn="true"
              :data="JSON.stringify({ parent: c.country ? c.country.id : null })"
              :parent="c.state ? c.state.id : null"
              class="mb-2"
            />
            <FlexibleAutocomplete
              v-model="c.education_field"
              title="certificate"
              type="education_field"
              :multiple="false"
              :currency="c.currencyId"
              :fetchData="c.fetchApi"
              class="mb-2"
            />
            <FlexibleAutocomplete
              v-model="c.magor"
              title="magor"
              type="magor"
              :multiple="false"
              :currency="c.currencyId"
              :fetchData="c.fetchApi"
              class="mb-2"
            />
            <v-text-field v-model="c.childCount" :label="$t('childCount')" dense outlined clearable hide-details="auto" class="mb-2" />
          </template>

          <!-- Financial -->
          <template v-else-if="activeSection === 'financial'">
            <v-select
              v-model="c.nature_initial_price"
              :label="$t('natureAccount')"
              :items="c.natureItems"
              dense
              outlined
              hide-details="auto"
              :disabled="!c.initialCheck"
              item-value="value"
              item-text="text"
              class="mb-2"
            />
            <money
              v-model="c.initial_price"
              :label="$t('initialPrice')"
              :dense="true"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="c.options"
              :disabled="!c.initialCheck"
              class="mb-3 dense"
            />
          </template>

          <!-- Custom fields -->
          <template v-else-if="activeSection === 'customFields'">
            <custom-fields
              ref="refCustomFields"
              v-model="c.customFields"
              :value="c.customFields"
              type-prop="accountCustomFields"
              :mobile="true"
            />
          </template>

          <!-- Other -->
          <template v-else-if="activeSection === 'other'">
            <v-text-field v-model="c.custom_code" :label="$t('Custom financial ID')" dense outlined clearable hide-details="auto" class="mb-2" />
            <autocomplete
              v-model="c.branch"
              :title="$t('branch')"
              type="branch"
              :set-init="true"
              :value="c.branch"
              class="mb-2"
            />
            <autocomplete
              v-model="c.attractionMethod"
              :title="$t('attractionMethod')"
              type="attractionMethod"
              :value="c.attractionMethod"
              class="mb-2"
            />
            <div class="cfm-field cfm-field--area">
              <span class="cfm-field__label">{{ $t("description") }}</span>
              <textarea
                v-model="c.content"
                class="cfm-field__textarea"
                rows="5"
              />
            </div>
          </template>

          <!-- Personnely: insurer -->
          <template v-else-if="activeSection === 'personnelyInsurer'">
            <FlexibleAutocomplete
              v-model="c.insurance_job_position"
              title="InsurerRole"
              type="insurance_job_position"
              :multiple="false"
              :currency="c.currencyId"
              :fetchData="c.fetchApi"
              class="mb-2"
            />
            <FlexibleAutocomplete
              v-model="c.insurance_type"
              title="InsurerType"
              type="insurance_type"
              :multiple="false"
              :currency="c.currencyId"
              :fetchData="c.fetchApi"
              class="mb-2"
            />
            <v-text-field
              v-model="c.InsurerName"
              :label="$t('InsurerName')"
              dense
              outlined
              clearable
              hide-details="auto"
              class="mb-2"
            />
            <v-text-field
              v-model="c.InsurerNumber"
              :label="$t('InsurerNumber')"
              dense
              outlined
              clearable
              hide-details="auto"
              class="mb-2"
            />
            <v-text-field
              v-model="c.InsurerRecordToMonth"
              :label="$t('InsurerRecordToMonth')"
              dense
              outlined
              clearable
              hide-details="auto"
            />
          </template>

          <!-- Personnely: service -->
          <template v-else-if="activeSection === 'personnelyService'">
            <FlexibleAutocomplete
              v-model="c.soldier_status"
              title="Military Service Status"
              type="soldier_status"
              :currency="c.currencyId"
              :multiple="false"
              :fetchData="c.fetchApi"
              class="mb-2"
            />
            <FlexibleAutocomplete
              v-model="c.job_field"
              title="jobCategory"
              type="job_field"
              :multiple="false"
              :currency="c.currencyId"
              :fetchData="c.fetchApi"
              class="mb-2"
            />
            <v-text-field
              v-model="c.ServicePlace"
              :label="$t('ServicePlace')"
              dense
              outlined
              clearable
              hide-details="auto"
              class="mb-2"
            />
            <FlexibleAutocomplete
              v-model="c.soldier_location_type"
              title="ServicePlaceStatus"
              type="soldier_location_type"
              :multiple="false"
              :currency="c.currencyId"
              :fetchData="c.fetchApi"
              class="mb-2"
            />
            <FlexibleAutocomplete
              v-model="c.exemption_type"
              title="ExemptType"
              type="exemption_type"
              :currency="c.currencyId"
              :multiple="false"
              :fetchData="c.fetchApi"
            />
          </template>
        </div>
        <div class="cfm-section-sheet__footer">
          <button type="button" class="cfm-section-sheet__save" @click="sectionSheet = false">
            {{ $t("confirm") }}
          </button>
        </div>

        <!-- Contact geo pickers (hidden; opened via Digikala rows) -->
        <div v-show="activeSection === 'contact'" class="cfm-picker-host" aria-hidden="true">
          <aicomplete
            ref="refCountry"
            v-model="c.country"
            title="country"
            type="country"
            :val="c.country"
            :new-btn="true"
          />
          <aicomplete
            ref="refState"
            v-model="c.state"
            title="state"
            type="state"
            :val="c.state"
            :new-btn="true"
            :data="JSON.stringify({ parent: c.country ? c.country.id : null })"
            :parent="c.country ? c.country.id : null"
          />
          <aicomplete
            ref="refCity"
            v-model="c.city"
            title="city"
            type="city"
            :val="c.city"
            :new-btn="true"
            :data="JSON.stringify({ parent: c.country ? c.country.id : null })"
            :parent="c.state ? c.state.id : null"
          />
        </div>
      </v-card>
    </v-bottom-sheet>

    <!-- Date picker sheet -->
    <v-bottom-sheet v-model="dateSheet" eager>
      <v-card class="amf-sheet cfm-section-sheet" dir="rtl">
        <div class="amf-sheet__handle" />
        <div class="amf-sheet__header">
          <span class="amf-sheet__header-spacer" />
          <div class="amf-sheet__title">{{ dateSheetLabel }}</div>
          <button type="button" class="amf-sheet__back" @click="dateSheet = false">
            <v-icon size="22" color="#37474F">mdi-arrow-left</v-icon>
          </button>
        </div>
        <div class="cfm-section-sheet__scroll">
          <div class="cfm-date">
            <div class="cfm-date__selected">
              <span class="cfm-date__label">{{ dateSheetLabel }}</span>
              <strong class="cfm-date__value">{{ dateSheetDisplay || "—" }}</strong>
              <button v-if="dateSheetDisplay" type="button" class="cfm-date__clear" @click="clearDateSheetValue">
                {{ $t("clear") }}
              </button>
            </div>
            <date-picker
              v-if="dateSheet && dateSheetTarget"
              v-model="dateSheetProxy"
              inline
              simple
              auto-submit
              :locale="$store.state.date_locale"
              :format="$store.state.date_format"
              class="cfm-date__picker"
              color="#5B7C99"
            />
          </div>
        </div>
        <div class="cfm-section-sheet__footer">
          <button type="button" class="cfm-section-sheet__save" @click="dateSheet = false">
            {{ $t("confirm") }}
          </button>
        </div>
      </v-card>
    </v-bottom-sheet>

    <v-snackbar
      v-model="c.snakbar"
      :color="c.snakbarColor ? c.snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ c.snakbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="c.snakbar = !c.snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import General from "../../../../../../Mixins/general";
import filePicker from "../../../../components/general/filePicker/index";
import FormAttachmentDoc from "../../../../components/general/FormAttachmentDoc";
import customFields from "../../../../components/general/customFields/index.vue";
import FlexibleAutocomplete from "../../../../components/general/patial/FlexibleAutocomplete.vue";

/**
 * Mobile customer/person form UI. Logic lives on customer.vue (inject customerForm).
 */
export default {
  name: "CustomerFormMobile",
  inject: ["customerForm"],
  mixins: [General],
  components: {
    autocomplete: () => import("../../../../components/general/patial/autocomplete"),
    aicomplete: () => import("../../../../components/general/AIcomplete/index"),
    Tag: () => import("../../../../components/general/Tag/tag"),
    filePicker,
    FormAttachmentDoc,
    customFields,
    FlexibleAutocomplete,
  },
  data() {
    return {
      mobileValid: true,
      mobileTab: "main",
      sectionSheet: false,
      activeSection: null,
      integratorSubTab: "woocommerce",
      wooOpenIndex: 0,
      dateSheet: false,
      dateSheetTarget: null,
      dateSheetField: null,
      dateSheetLabel: "",
    };
  },
  computed: {
    c() {
      return this.customerForm;
    },
    showPersonnelyChip() {
      return !!this.c.personnely;
    },
    shellStyle() {
      const appBar = 52;
      // Mobile bottom nav is dashboard-only.
      const bottomNav = 0;
      const height = `calc(100dvh - ${appBar}px)`;
      return {
        height,
        maxHeight: height,
        marginBottom: bottomNav ? `-${bottomNav}px` : "0",
        paddingBottom: "0",
        boxSizing: "border-box",
      };
    },
    actionsStyle() {
      const bottomNav = 0;
      return {
        paddingBottom: bottomNav
          ? `calc(${bottomNav + 10}px + env(safe-area-inset-bottom, 0px))`
          : "calc(8px + env(safe-area-inset-bottom, 0px))",
      };
    },
    integratorSubTabs() {
      return [
        { key: "woocommerce", label: this.$t("woocommerce"), icon: "mdi-wordpress" },
        { key: "digikala", label: this.$t("digikala"), icon: "mdi-shopping-outline" },
        { key: "portal", label: this.$t("portal"), icon: "mdi-web" },
        { key: "sazito", label: this.$t("sazito"), img: require("@/assets/sazito.png") },
        {
          key: "magnet",
          label: this.$t("magnet"),
          img: require("@/assets/integrators/logo-magnet.png"),
        },
        { key: "webzi", label: this.$t("webzi"), img: require("@/assets/webzi.png") },
      ];
    },
    sectionTitle() {
      const map = {
        contact: this.$t("otherCantactInfo"),
        grouping: this.$t("grouping,tags"),
        identity: this.$t("otherIdentityInformation"),
        financial: this.$t("financialInformation"),
        customFields: this.$t("customFields"),
        other: this.$t("otherInformation"),
        personnelyInsurer: this.$t("InsurerInformation"),
        personnelyService: this.$t("Serviceinformation"),
      };
      return map[this.activeSection] || "";
    },
    sectionHasAddAction() {
      return this.activeSection === "customFields";
    },
    sectionAddLabel() {
      if (this.activeSection === "customFields") return this.$t("addCustomeField");
      return this.$t("add");
    },
    sectionAddHint() {
      if (this.activeSection === "customFields") {
        return this.$t("clickForAddCustomeField");
      }
      return "";
    },
    countryText() {
      return this.entityLabel(this.c.country);
    },
    stateText() {
      return this.entityLabel(this.c.state);
    },
    cityText() {
      return this.entityLabel(this.c.city);
    },
    roleText() {
      return this.entityLabel(this.c.role);
    },
    entrepotAccessText() {
      return this.entitiesLabel(this.c.entrepotAccess);
    },
    branchAccessText() {
      return this.entitiesLabel(this.c.branchAccess);
    },
    departmentAccessText() {
      return this.entitiesLabel(this.c.departmentAccess);
    },
    bankAccessText() {
      return this.entitiesLabel(this.c.bank);
    },
    dateSheetDisplay() {
      if (!this.dateSheetTarget || !this.dateSheetField) return "";
      const v = this.dateSheetTarget[this.dateSheetField];
      return v != null && v !== "" ? String(v) : "";
    },
    dateSheetProxy: {
      get() {
        if (!this.dateSheetTarget || !this.dateSheetField) return null;
        return this.dateSheetTarget[this.dateSheetField];
      },
      set(val) {
        if (!this.dateSheetTarget || !this.dateSheetField) return;
        this.dateSheetTarget[this.dateSheetField] = val;
      },
    },
  },
  watch: {
    "c.panel": {
      handler(panel, prev) {
        if (!Array.isArray(panel) || !panel.includes(2)) return;
        if (Array.isArray(prev) && prev.includes(2)) return;
        if (this.mobileTab !== "main") {
          this.setMobileTab("main");
        }
        this.openSection("identity");
      },
    },
    sectionSheet(val) {
      if (val) {
        this.$nextTick(() => this.syncRefsToParent());
      }
    },
  },
  mounted() {
    this.syncRefsToParent();
  },
  methods: {
    onBack() {
      if (this.c.idProp != null || this.c.returnObject) {
        this.c.cancel();
        return;
      }
      this.$router.go(-1);
    },
    onStatusChange(val) {
      this.c.status = val ? "active" : "deactive";
    },
    toggleRole(field) {
      if (field !== "lead" && this.c.lead === "active") return;
      if (field === "lead" && this.c.personel === "active") return;
      const map = {
        lead: "lead",
        personnely: "personnely",
        personel: "personel",
        student: "student",
        teacher: "teacher",
        visitor: "visitor",
        investor: "investor",
        translator: "translator",
      };
      const key = map[field];
      if (!key) return;
      if (field === "lead" && this.c.lead === "active") {
        this.c.lead = null;
        return;
      }
      if (field !== "lead" && this.c[key] === "active") {
        this.c[key] = field === "personnely" ? false : null;
        return;
      }
      if (field === "lead") {
        this.c.lead = "active";
        return;
      }
      this.c[key] = "active";
    },
    setMobileTab(tab) {
      this.mobileTab = tab || "main";
      this.sectionSheet = false;
      if (tab === "main") {
        this.c.activeTab = 0;
      } else if (tab === "user") {
        this.c.activeTab = 1;
      } else if (tab === "integrator") {
        this.c.activeTab = this.c.activeUser ? 2 : 1;
      } else if (tab === "documents") {
        let idx = 1;
        if (this.c.activeUser) idx++;
        idx++;
        this.c.activeTab = idx;
      } else if (tab === "sms") {
        this.c.activeTab = 4;
      } else if (tab === "personnely" && this.c.personnelyTabIndex != null) {
        this.c.activeTab = this.c.personnelyTabIndex;
      }
      this.$nextTick(() => {
        const scroller = this.$el && this.$el.querySelector(".cfm__scroll");
        if (scroller) scroller.scrollTop = 0;
        this.syncRefsToParent();
      });
    },
    openSection(key) {
      this.activeSection = key;
      this.sectionSheet = true;
    },
    onSectionAdd() {
      if (this.activeSection !== "customFields") return;
      this.$nextTick(() => {
        const ref = this.$refs.refCustomFields;
        if (ref && typeof ref.addRow === "function") {
          ref.addRow();
        }
      });
    },
    entityLabel(val) {
      if (val == null || val === "") return "";
      if (typeof val === "string" || typeof val === "number") return String(val);
      return (val && (val.name || val.title || val.text || val.label)) || "";
    },
    entitiesLabel(val) {
      if (val == null || val === "") return "";
      if (Array.isArray(val)) {
        return val
          .map((item) => this.entityLabel(item))
          .filter(Boolean)
          .join("، ");
      }
      return this.entityLabel(val);
    },
    openPicker(refName) {
      const ref = this.$refs[refName];
      const comp = Array.isArray(ref) ? ref[0] : ref;
      if (comp && typeof comp.openMobileDialog === "function") {
        comp.openMobileDialog();
      }
    },
    openDateSheet(target, field, label) {
      this.dateSheetTarget = target;
      this.dateSheetField = field;
      this.dateSheetLabel = label || this.$t("date");
      this.dateSheet = true;
    },
    clearDateSheetValue() {
      if (!this.dateSheetTarget || !this.dateSheetField) return;
      this.dateSheetTarget[this.dateSheetField] = null;
    },
    addWooMobile() {
      if (!this.c || typeof this.c.addWoocommerceIdItems !== "function") return;
      this.c.addWoocommerceIdItems();
      this.$nextTick(() => {
        const len = (this.c.woocommerceIdItems && this.c.woocommerceIdItems.length) || 0;
        this.wooOpenIndex = len ? len - 1 : -1;
      });
    },
    toggleWooCard(index) {
      this.wooOpenIndex = this.wooOpenIndex === index ? -1 : index;
    },
    panelNameLabel(val) {
      if (!val) return "";
      if (typeof val === "string") return val;
      return val.name || val.title || val.text || "";
    },
    wooCardSummary(item) {
      if (!item) return "";
      const panel = this.panelNameLabel(item.woocommercePanelName);
      const id = item.woocommerceId ? String(item.woocommerceId) : "";
      if (panel && id) return panel + " · " + id;
      return panel || id || "";
    },
    syncRefsToParent() {
      const parentRefs = this.c.$refs;
      if (!parentRefs) return;
      const assign = (name) => {
        const local = this.$refs[name];
        if (local) parentRefs[name] = local;
      };
      [
        "form",
        "refFilePicker",
        "refFilePickerDocument",
        "refCountry",
        "refState",
        "refCity",
        "refCategory",
        "refBirthDate",
        "refBusinessName",
        "refFinancialCode",
        "refFathersName",
        "refBirthCertificateNumber",
        "refDateOfBirthCertificate",
        "refStatePlaceofBirth",
        "refCityPlaceofBirth",
        "refStatePlaceOfBirthCertificate",
        "refCityPlaceOfBirthCertificate",
        "refRole",
        "refEntrepot",
        "refBranchAccess",
        "refDepartmentAccess",
        "refBank",
        "refCustomFields",
      ].forEach(assign);
    },
    submitCreate() {
      if (this.$refs.form && !this.$refs.form.validate()) return;
      this.syncRefsToParent();
      this.c.create();
    },
    submitUpdate() {
      if (this.$refs.form && !this.$refs.form.validate()) return;
      this.syncRefsToParent();
      this.c.update();
    },
  },
};
</script>

<style scoped>
.cfm {
  display: flex;
  flex-direction: column;
  background: #f3f5f7;
  overflow: hidden;
  width: 100%;
  position: relative;
}
.cfm-header {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: 40px 1fr 40px;
  align-items: center;
  gap: 8px;
  min-height: 52px;
  padding: 8px 12px;
  background: #fff;
  border-bottom: 1px solid #e8eef2;
  direction: ltr;
}
.cfm-header__title {
  margin: 0;
  text-align: center;
  font-size: 16px;
  font-weight: 800;
  color: #263238;
  direction: rtl;
}
.cfm-header__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 0;
  background: transparent;
  border-radius: 10px;
  cursor: pointer;
}
.cfm-header__icon:active {
  background: #eef2f5;
}
.cfm__form {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.cfm__scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 10px 12px 16px;
}
.cfm__scroll--documents {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 10px;
}
.cfm-advanced--top {
  flex: 0 0 auto;
  margin: 0;
  padding: 8px 12px 10px;
  background: #f3f5f7;
  border-bottom: 1px solid #e8eef2;
  z-index: 2;
}
.cfm-advanced__chips {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 2px 2px;
  scrollbar-width: none;
}
.cfm-advanced__chips::-webkit-scrollbar {
  display: none;
}
.cfm-advanced__chip {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 36px;
  padding: 8px 12px;
  border: 1px solid #c5d0e0;
  border-radius: 999px;
  background: #eef3f8;
  color: #455a64;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
}
.cfm-advanced__chip:active {
  background: #e0e7f0;
}
.cfm-advanced__chip--on {
  border-color: #5b7c99;
  background: #5b7c99;
  color: #fff;
}
.cfm-type {
  display: flex;
  flex: 0 0 auto;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dbe3ea;
}
.cfm-type--compact {
  max-width: 46%;
}
.cfm-type__item {
  flex: 1 1 auto;
  border: 0;
  background: transparent;
  padding: 7px 10px;
  font-size: 12px;
  font-weight: 700;
  color: #78909c;
  cursor: pointer;
  white-space: nowrap;
  line-height: 1.2;
}
.cfm-type__item--active {
  background: #5b7c99;
  color: #fff;
}
.cfm-type__item:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.cfm-flags {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 6px;
  margin-bottom: 10px;
  min-width: 0;
}
.cfm-flag {
  border: 1px solid #c5d0da;
  background: #fff;
  color: #607d8b;
  border-radius: 8px;
  padding: 7px 9px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  line-height: 1.2;
  white-space: nowrap;
}
.cfm-flag--on {
  border-color: #5b7c99;
  background: #dde6ee;
  color: #37474f;
}
.cfm-flag:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.cfm-card {
  background: #fff;
  border: 1px solid #e8eef2;
  border-radius: 12px;
  margin-bottom: 10px;
  overflow: hidden;
}
.cfm-user-card {
  padding: 12px 14px 14px;
}
.cfm-user-card__fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.cfm-integ__input--disabled,
.cfm-integ__input:disabled {
  background: #f5f7f9 !important;
  color: #90a4ae !important;
  cursor: default;
}
.cfm-integ__picker--multi {
  height: auto !important;
  max-height: none !important;
  flex: 0 0 auto !important;
  overflow: visible !important;
}
.cfm-integ__picker--multi ::v-deep .v-input__control,
.cfm-integ__picker--multi ::v-deep .v-input__slot {
  min-height: 40px !important;
  height: auto !important;
}
.cfm-personnely-work {
  padding: 12px 14px 14px;
}
.cfm-personnely-work__title {
  margin: 0 2px 12px;
  font-size: 14px;
  font-weight: 800;
  color: #37474f;
  text-align: right;
}
.cfm-personnely-work__fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.cfm-personnely-work__dates {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
}
.cfm-personnely-work__dates > .cfm-composer-field {
  flex: 1 1 0;
  min-width: 0;
}
.cfm-integ__input--date {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;
  text-align: right;
  font: inherit;
}
.cfm-integ__input--date > span {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
  color: #37474f;
}
.cfm-integ__input--date .cfm-integ__ph {
  color: #b0bec5;
  font-weight: 600;
}
.cfm-hero__body {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.cfm-hero__row {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: stretch;
  height: 88px;
  min-height: 88px;
  max-height: 88px;
}
.cfm-hero__avatar {
  flex: 0 0 88px;
  width: 88px;
  min-width: 88px;
  height: 88px;
  display: flex;
}
.cfm-hero__avatar ::v-deep .v-card {
  background: transparent !important;
  box-shadow: none !important;
  width: 88px !important;
  height: 88px !important;
  margin: 0 !important;
}
.cfm-hero__avatar ::v-deep .v-avatar {
  border-radius: 8px !important;
  width: 88px !important;
  min-width: 88px !important;
  height: 88px !important;
  max-height: 88px !important;
  overflow: hidden;
}
.cfm-hero__avatar ::v-deep .v-avatar .v-image,
.cfm-hero__avatar ::v-deep .v-avatar img {
  border-radius: 8px !important;
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
}
.cfm-hero__main {
  flex: 1 1 auto;
  min-width: 0;
  height: 88px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
}
.cfm-hero__name,
.cfm-hero__lastname {
  margin: 0 !important;
  padding: 0 !important;
  flex: 0 0 40px;
  height: 40px;
  max-height: 40px;
  overflow: hidden;
}
.cfm-hero__name ::v-deep .v-input__control,
.cfm-hero__lastname ::v-deep .v-input__control {
  margin-bottom: 0 !important;
}
.cfm-hero__name ::v-deep .v-input__slot,
.cfm-hero__lastname ::v-deep .v-input__slot {
  margin-bottom: 0 !important;
  min-height: 40px !important;
  height: 40px !important;
}
.cfm-hero__name ::v-deep .v-text-field__details,
.cfm-hero__lastname ::v-deep .v-text-field__details {
  display: none !important;
}
.cfm-hero__toggles {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}
.cfm-hero__toggles .cfm-type--compact {
  max-width: none;
  flex: 0 1 auto;
}
.cfm-hero__fields {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.cfm-hero__fields-gap {
  flex: 0 0 20px;
  height: 20px;
  width: 100%;
  pointer-events: none;
}
.cfm-hero__field {
  margin: 0 !important;
  padding: 0 !important;
  flex: 0 0 auto;
}
.cfm-hero__field ::v-deep .v-input__control {
  margin-bottom: 0 !important;
}
.cfm-hero__field ::v-deep .v-input__slot {
  margin-bottom: 0 !important;
}
.cfm-hero__field ::v-deep .v-text-field__details {
  display: none !important;
  margin: 0 !important;
  min-height: 0 !important;
  height: 0 !important;
  padding: 0 !important;
  overflow: hidden;
}
.cfm-hero__status-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  padding-top: 16px;
  border-top: 1px solid #eef2f5;
}
.cfm-hero__status-label {
  font-size: 14px;
  font-weight: 700;
  color: #455a64;
}
.cfm-sections__row {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 12px;
  border: 0;
  border-bottom: 1px solid #eef2f5;
  background: #fff;
  text-align: right;
  cursor: pointer;
}
.cfm-sections__row:last-child {
  border-bottom: 0;
}
.cfm-sections__copy {
  flex: 1 1 auto;
  min-width: 0;
}
.cfm-sections__title {
  font-size: 14px;
  font-weight: 800;
  color: #37474f;
}
.cfm-sections__hint {
  margin-top: 3px;
  font-size: 12px;
  color: #90a4ae;
}
.cfm-tab-panel {
  padding-bottom: 8px;
}
.cfm-check-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cfm-integ__chips {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 2px 2px 12px;
  margin-bottom: 4px;
  scrollbar-width: none;
}
.cfm-integ__chips::-webkit-scrollbar {
  display: none;
}
.cfm-integ__chip {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border: 1px solid #c5d0e0;
  border-radius: 999px;
  background: #fff;
  font-size: 11px;
  font-weight: 700;
  color: #5b7c99;
  cursor: pointer;
}
.cfm-integ__chip--on {
  background: #5b7c99;
  border-color: #5b7c99;
  color: #fff;
}
.cfm-integ__chip-logo {
  width: 16px;
  height: 16px;
  object-fit: contain;
}
.cfm-integ__panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.cfm-integ__add {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  min-height: 44px;
  border: 1px solid #c5d0e0;
  border-radius: 10px;
  background: #e8edf5;
  color: #5a6b85;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}
.cfm-integ__add:active {
  background: #dde4ef;
}
.cfm-integ__add:disabled {
  opacity: 0.6;
  cursor: default;
}
.cfm-integ__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 28px 16px;
  text-align: center;
  border: 1px dashed #d5dde5;
  border-radius: 12px;
  background: #f7f9fc;
}
.cfm-integ__empty-title {
  font-size: 14px;
  font-weight: 800;
  color: #546e7a;
  line-height: 1.4;
}
.cfm-integ__empty-hint {
  font-size: 12px;
  font-weight: 600;
  color: #90a4ae;
  line-height: 1.5;
}
.cfm-integ__card {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 10px 12px;
  border: 1px solid #e0e4e8;
  border-radius: 12px;
  background: #fff;
}
.cfm-integ__card--open {
  padding-bottom: 12px;
}
.cfm-integ__card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  cursor: pointer;
  user-select: none;
}
.cfm-integ__card--open .cfm-integ__card-top {
  padding-bottom: 10px;
  margin-bottom: 12px;
  border-bottom: 1px solid #eef2f5;
}
.cfm-integ__card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1 1 auto;
}
.cfm-integ__card-titles {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.cfm-integ__card-title {
  font-size: 12px;
  font-weight: 700;
  color: #78909c;
  line-height: 1.3;
}
.cfm-integ__card-summary {
  font-size: 14px;
  font-weight: 700;
  color: #37474f;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cfm-integ__card-remove {
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f8bbd0;
  border-radius: 10px;
  background: #fce4ec;
  cursor: pointer;
}
.cfm-integ__card-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.cfm-integ__simple {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 12px;
  border: 1px solid #e0e4e8;
  border-radius: 12px;
  background: #fff;
}
.cfm-integ__input {
  width: 100%;
  min-height: 40px;
  padding: 0 10px;
  border: 1px solid #cfd8dc;
  border-radius: 8px;
  background: #fff;
  color: #37474f;
  font-size: 15px;
  font-weight: 700;
  text-align: right;
  box-sizing: border-box;
  outline: none;
}
.cfm-integ__input:focus {
  border-color: #90caf9;
  background: #e3f2fd;
}
.cfm-integ__input::placeholder {
  color: #b0bec5;
  font-weight: 600;
  opacity: 1;
}
.cfm-integ__input:disabled {
  background: #f5f7f9;
  color: #90a4ae;
  cursor: default;
}
.cfm-integ__picker {
  display: block;
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
  flex: 0 0 40px;
  height: 40px !important;
  max-height: 40px !important;
  overflow: hidden !important;
}
.cfm-integ__picker ::v-deep .v-input,
.cfm-integ__picker ::v-deep .v-text-field,
.cfm-integ__picker ::v-deep .v-autocomplete {
  margin: 0 !important;
  margin-top: 0 !important;
  padding: 0 !important;
  padding-top: 0 !important;
}
.cfm-integ__picker ::v-deep .v-input__control {
  min-height: 40px !important;
  height: 40px !important;
}
.cfm-integ__picker ::v-deep .v-input__slot {
  min-height: 40px !important;
  height: 40px !important;
  margin: 0 !important;
  padding: 0 10px !important;
  border: 1px solid #cfd8dc !important;
  border-radius: 8px !important;
  background: #fff !important;
  box-shadow: none !important;
}
.cfm-integ__picker ::v-deep fieldset {
  display: none !important;
}
.cfm-integ__picker ::v-deep .v-input__slot::before,
.cfm-integ__picker ::v-deep .v-input__slot::after {
  display: none !important;
}
.cfm-integ__picker ::v-deep .v-label {
  display: none !important;
}
.cfm-integ__picker ::v-deep .v-text-field__details,
.cfm-integ__picker ::v-deep .v-messages {
  display: none !important;
  min-height: 0 !important;
  height: 0 !important;
}
.cfm-integ__picker ::v-deep .v-input__append-inner,
.cfm-integ__picker ::v-deep .v-input__prepend-inner {
  margin-top: 0 !important;
  align-self: center !important;
}
.cfm-composer-field {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
}
.cfm-composer-field__label {
  display: block;
  margin: 0 2px 6px;
  font-size: 13px;
  font-weight: 600;
  color: #455a64;
  line-height: 1.4;
  text-align: right;
}
.cfm-composer-field--switch {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.cfm-composer-field--switch .cfm-composer-field__label {
  margin: 0;
}
.cfm-documents {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  padding: 0;
  overflow: hidden;
}
.cfm-documents__card {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
}
.cfm-actions {
  flex: 0 0 auto;
  padding: 10px 12px 8px;
  background: #fff;
  border-top: 1px solid #e0e6ed;
  z-index: 3;
}
.cfm-actions__primary {
  background: #5b7c99 !important;
  color: #fff !important;
  border-radius: 10px !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
  box-shadow: none !important;
}
.cfm-section-sheet {
  display: flex;
  flex-direction: column;
  max-height: 88vh;
  overflow: hidden;
}
.cfm-section-sheet__toolbar {
  flex: 0 0 auto;
  padding: 0 16px 12px;
  background: #fff;
}
.cfm-section-sheet__toolbar--composer {
  border-bottom: 1px solid #eef2f5;
}
.cfm-section-sheet__hint {
  margin: 0 0 12px;
  font-size: 12px;
  font-weight: 600;
  color: #78909c;
  line-height: 1.5;
  text-align: right;
}
.cfm-section-sheet__add {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  min-height: 44px;
  border: 1px solid #c5d0e0;
  border-radius: 10px;
  background: #e8edf5;
  color: #5a6b85;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}
.cfm-section-sheet__add:active {
  background: #dde4ef;
}
.cfm-section-sheet__scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 12px 16px 16px;
  display: flex;
  flex-direction: column;
}
/* Stack spacing for outlined Vuetify sections (identity/other/…) */
.cfm-section-sheet__scroll.amf-sheet__body--stack > *:not(.cfm-sheet-fields):not(.cfm-picker-host) {
  flex: 0 0 auto !important;
  width: 100%;
  margin-top: 0 !important;
  margin-bottom: 14px !important;
  box-sizing: border-box;
}
.cfm-section-sheet__scroll.amf-sheet__body--stack > *:not(.cfm-sheet-fields):not(.cfm-picker-host):last-child {
  margin-bottom: 4px !important;
}
.cfm-sheet-fields {
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  margin: 0 !important;
}
.cfm-field {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 52px;
  padding: 10px 2px;
  border-bottom: 1px solid #e8eef2;
}
.cfm-field:last-child {
  border-bottom: 0;
}
.cfm-field--select {
  cursor: pointer;
}
.cfm-field--select:active {
  background: #f7f9fc;
}
.cfm-field--switch {
  justify-content: space-between;
  width: 100%;
  margin-bottom: 0 !important;
  border-bottom: 0;
  padding: 4px 2px;
}
.cfm-field__switch {
  margin: 0 !important;
  padding: 0 !important;
  flex: 0 0 auto;
}
.cfm-field__switch ::v-deep .v-input__slot {
  margin-bottom: 0 !important;
}
.cfm-field--area {
  align-items: flex-start;
  min-height: 120px;
  padding: 10px 2px 12px;
  flex-direction: column;
  gap: 8px;
}
.cfm-field__label-wrap {
  flex: 0 0 auto;
  max-width: 42%;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.cfm-field--area .cfm-field__label-wrap {
  max-width: none;
}
.cfm-field__label {
  font-size: 12px;
  font-weight: 600;
  color: #78909c;
  line-height: 1.3;
  text-align: right;
  white-space: nowrap;
}
.cfm-field__control {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  border: 0;
  background: transparent;
  padding: 6px 0;
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #263238;
  text-align: right;
  direction: rtl;
  line-height: 1.3;
}
.cfm-field__control--select {
  cursor: pointer;
  width: 100%;
}
.cfm-field__control--select > span {
  flex: 1 1 auto;
  min-width: 0;
  text-align: right;
  direction: rtl;
}
.cfm-field__input {
  width: 100%;
  outline: none;
  cursor: text;
  font-family: inherit;
  background: transparent;
  text-align: right;
  direction: rtl;
  unicode-bidi: plaintext;
}
.cfm-field__input::placeholder,
.cfm-field__textarea::placeholder,
.cfm-field__placeholder {
  color: #b0bec5;
  font-weight: 500;
  text-align: right;
  direction: rtl;
  opacity: 1;
}
.cfm-field__textarea {
  width: 100%;
  min-height: 88px;
  resize: vertical;
  border: 1px solid #dbe3ea;
  border-radius: 10px;
  outline: none;
  background: #f7f9fc;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  color: #263238;
  text-align: right;
  direction: rtl;
  line-height: 1.5;
  padding: 12px;
  box-sizing: border-box;
}
.cfm-field__textarea:focus {
  border-color: #5b7c99;
  background: #fff;
}
.cfm-section-sheet__footer {
  flex: 0 0 auto;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
  border-top: 1px solid #eef2f5;
}
.cfm-section-sheet__save {
  width: 100%;
  min-height: 44px;
  border: 0;
  border-radius: 10px;
  background: #5b7c99;
  color: #fff;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
}
.cfm-date__selected {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 14px;
  border: 1px solid #e0e6ed;
  border-radius: 12px;
  background: #f7f9fc;
  margin-bottom: 12px;
}
.cfm-date__label {
  width: 100%;
  font-size: 12px;
  font-weight: 600;
  color: #78909c;
}
.cfm-date__value {
  font-size: 18px;
  font-weight: 800;
  color: #263238;
}
.cfm-date__clear {
  border: 0;
  background: transparent;
  color: #e91e63;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.cfm-date__picker ::v-deep .vpd-main,
.cfm-date__picker ::v-deep .vpd-wrapper,
.cfm-date__picker ::v-deep .vpd-container,
.cfm-date__picker ::v-deep .vpd-content {
  width: 100% !important;
  max-width: 100% !important;
  box-shadow: none !important;
  border: 1px solid #e0e6ed !important;
  border-radius: 12px !important;
}
.cfm-picker-host {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  opacity: 0;
  pointer-events: none;
}
.cfm-branch-panel ::v-deep .v-expansion-panel {
  border: 1px solid silver;
  margin-bottom: 7px;
  border-radius: 4px;
}
.cfm ::v-deep .amf-sheet__handle {
  width: 40px;
  height: 4px;
  margin: 10px auto 6px;
  border-radius: 999px;
  background: #cfd8dc;
}
.cfm ::v-deep .amf-sheet__header {
  display: grid;
  grid-template-columns: 40px 1fr 40px;
  align-items: center;
  padding: 4px 8px 12px;
  direction: ltr;
}
.cfm ::v-deep .amf-sheet__title {
  text-align: center;
  font-size: 16px;
  font-weight: 800;
  color: #263238;
  direction: rtl;
}
.cfm ::v-deep .amf-sheet__back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 0;
  background: transparent;
  border-radius: 10px;
  cursor: pointer;
}
.cfm ::v-deep .amf-sheet__header-spacer {
  width: 40px;
}
</style>

<!-- Unscoped: beat global desktop attachment styles (same look as pay/cash mobile) -->
<style>
.cfm-documents .cfm-documents__card.app-form-card--documents {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.cfm-documents .app-form-card__header {
  flex: 0 0 auto;
  padding: 12px 14px 8px;
}

.cfm-documents .app-form-card__title {
  font-size: 14px;
  font-weight: 700;
  color: #37474f;
  text-align: right;
}

.cfm-documents .app-form-card__body--documents {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  padding: 0 12px 12px !important;
}

.cfm-documents .app-form-card__body--documents .attachment-wrap,
.cfm-documents .app-form-card__body--documents .attachment-layout {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  width: 100% !important;
}

.cfm-documents .app-form-card__body--documents .attachment-top {
  flex: 0 0 auto !important;
}

.cfm-documents .app-form-card__body--documents .attachment-dropzone {
  max-width: 100% !important;
  min-height: 88px !important;
  border: 1.5px dashed #b0b7c3 !important;
  border-radius: 4px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-direction: column !important;
  text-align: center !important;
  cursor: pointer !important;
  background: #f7f7f8 !important;
}

.cfm-documents .app-form-card__body--documents .attachment-hint {
  color: #6b7280 !important;
}

.cfm-documents .app-form-card__body--documents .attachment-wrap .v-card {
  box-shadow: none !important;
  background: transparent !important;
}

.cfm-documents .app-form-card__body--documents .attachment-wrap .v-card > .v-form > .v-btn,
.cfm-documents .app-form-card__body--documents .attachment-wrap .v-card > .v-form > .v-list {
  display: none !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table-toolbar {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
}

.cfm-documents .app-form-card__body--documents .attachment-count-badge {
  background: #f3f4f6 !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 4px !important;
  padding: 6px 10px !important;
}

.cfm-documents .app-form-card__body--documents .clear-btn {
  border-color: #ef9a9a !important;
  color: #d32f2f !important;
  background: #fff5f5 !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table-scroll {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  max-height: none !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  border: 1px solid #d9dde4 !important;
  border-radius: 10px !important;
  margin-top: 8px !important;
  margin-bottom: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  background: #fafbfc !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table {
  display: flex !important;
  flex-direction: column !important;
  flex: 1 1 auto !important;
  width: 100% !important;
  height: 100% !important;
  min-height: 100% !important;
  border-collapse: collapse !important;
  table-layout: auto !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table thead {
  display: none !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table tbody {
  display: flex !important;
  flex-direction: column !important;
  flex: 1 1 auto !important;
  min-height: 100% !important;
  height: 100% !important;
  padding: 10px !important;
  box-sizing: border-box !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table tbody tr {
  display: grid !important;
  grid-template-columns: 84px 1fr auto !important;
  grid-template-areas:
    "preview name ops"
    "preview type ops"
    "preview size ops" !important;
  gap: 2px 10px !important;
  align-items: stretch !important;
  background: #fff !important;
  border: 1px solid #e6e9ef !important;
  border-radius: 10px !important;
  padding: 10px !important;
  margin-bottom: 10px !important;
  height: auto !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table tbody tr td {
  border: none !important;
  border-bottom: none !important;
  padding: 0 !important;
  text-align: right !important;
  vertical-align: middle !important;
  font-size: inherit !important;
  height: auto !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table tbody tr td:nth-child(1) {
  grid-area: preview !important;
  align-self: stretch !important;
  display: flex !important;
  height: 100% !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table tbody tr td:nth-child(2) {
  grid-area: name !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  line-height: 1.35 !important;
  align-self: end !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table tbody tr td:nth-child(3) {
  grid-area: type !important;
  font-size: 11px !important;
  line-height: 1.35 !important;
  color: #8a94a6 !important;
  align-self: center !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table tbody tr td:nth-child(4) {
  grid-area: size !important;
  font-size: 11px !important;
  line-height: 1.35 !important;
  color: #8a94a6 !important;
  align-self: start !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table tbody tr td:nth-child(5) {
  grid-area: ops !important;
  align-self: center !important;
  justify-self: end !important;
}

.cfm-documents .app-form-card__body--documents .preview-cell {
  width: 84px !important;
  min-width: 84px !important;
  height: 100% !important;
  min-height: 84px !important;
  display: flex !important;
  align-items: stretch !important;
  justify-content: stretch !important;
  border-radius: 10px !important;
  background: #f3f5f7 !important;
  border: 1px solid #e8edf2 !important;
  overflow: hidden !important;
  cursor: pointer !important;
  box-sizing: border-box !important;
  align-self: stretch !important;
}

.cfm-documents .app-form-card__body--documents .preview-cell .preview-img {
  width: 100% !important;
  height: 100% !important;
  min-height: 84px !important;
  object-fit: cover !important;
  display: block !important;
  border-radius: 0 !important;
}

.cfm-documents .app-form-card__body--documents .amf-file-ops {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  gap: 8px !important;
  align-items: center !important;
}

.cfm-documents .app-form-card__body--documents .amf-file-ops__btn {
  width: 40px !important;
  height: 40px !important;
  border-radius: 10px !important;
  border: 1px solid #e0e4e8 !important;
  background: #fff !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  padding: 0 !important;
  flex-shrink: 0 !important;
}

.cfm-documents .app-form-card__body--documents .amf-file-ops__btn--open {
  border-color: rgba(21, 101, 192, 0.35) !important;
  background: rgba(21, 101, 192, 0.06) !important;
}

.cfm-documents .app-form-card__body--documents .amf-file-ops__btn--delete {
  border-color: rgba(229, 57, 53, 0.35) !important;
  background: rgba(229, 57, 53, 0.06) !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table tbody:has(.empty-row) {
  flex: 1 1 auto !important;
  min-height: 100% !important;
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: stretch !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table tbody tr:has(.empty-row) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex: 1 1 auto !important;
  width: 100% !important;
  min-height: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  border: 1px dashed #d9dde4 !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  padding: 24px !important;
  box-sizing: border-box !important;
  grid-template-columns: none !important;
  grid-template-areas: none !important;
}

.cfm-documents .app-form-card__body--documents .attachment-table tbody tr:has(.empty-row) td,
.cfm-documents .app-form-card__body--documents .attachment-table .empty-row {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  text-align: center !important;
  color: #90a4ae !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  grid-area: auto !important;
}
</style>
